module.exports = __webpack_public_path__ + "media/images/buoy-727db2941a93130f18c07792535b692a.png";